import { useEffect, useRef, useState } from "react";

const SEQUENCE = [
  "arrowup",
  "arrowup",
  "arrowdown",
  "arrowdown",
  "arrowleft",
  "arrowright",
  "arrowleft",
  "arrowright",
  "b",
  "a",
];

/** Tracks the Konami code to toggle chaos mode; Escape exits it. */
export function useKonami() {
  const [active, setActive] = useState(false);
  const buffer = useRef<string[]>([]);

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      const key = (e.key || "").toLowerCase();
      if (key === "escape") {
        setActive((prev) => (prev ? false : prev));
        return;
      }
      buffer.current = [...buffer.current, key].slice(-SEQUENCE.length);
      if (
        buffer.current.length === SEQUENCE.length &&
        buffer.current.every((k, i) => k === SEQUENCE[i])
      ) {
        buffer.current = [];
        setActive((prev) => !prev);
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  return { active, deactivate: () => setActive(false) };
}
